<template>
  <div>
    <board-empty-link :emptyLayout="emptyLayout" v-if="List.length === 0"></board-empty-link>
    <board-list-link :boardData="List" :listLayout="listLayout" :page="page" :boardName="boardName" v-else></board-list-link>
    <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                     :listLength="List.length"></pagination-link>
  </div>
</template>

<script>
import BoardListLink from "@/components/board/BoardListLink";
import PaginationLink from "@/components/board/PaginationLink";
import BoardEmptyLink from "@/components/board/BoardEmptyLink";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixin from "@/mixins/alertMixin";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";

const {filterConfig} = boardFilterUtil;
export default {
  name: "BoardListComponent",
  mixins: [filterMixins, listMixins, alertMixin, boardFilterUtil, boardTemplateUtil],
  components: {BoardEmptyLink, BoardListLink, PaginationLink,},
  props: {
    boardType: '',
    searchData: {
      default: ''
    },
    boardName:''
  },
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
      boardListSetData: this.setData,
    }
  },
  data() {
    return {
      listLayout: '',
      paginationLayout: '',
      getFunc: '',
      listApiParamSet: {},
      emptyLayout: '',
      filterSearch: '',
      page:{}
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.setFilterConfig(filterConfig)
    this.initConfig()
    this.setParserType('url', this.$route.fullPath);

  },
  mounted() {
    this.settingFilter();
    this.getList(true);
  },
  beforeDestroy() {

  },
  destroyed() {
  },
  computed: {},
  methods: {
    initConfig() {
      let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
      this.listLayout = boardTemplateConfig.listLayout;
      this.paginationLayout = boardTemplateConfig.paginationLayout;
      this.emptyLayout = boardTemplateConfig.emptyLayout
      let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
      this.getFunc = boardFilterConfig.getFunc
      this.listApiParamSet = boardFilterConfig.listApiParamSet;
      let pageRow = boardFilterConfig.pageRow ? boardFilterConfig.pageRow : 10;


      if (pageRow != this.filterSet.page.size) {
        this.filterSet.page.size = pageRow;
      }

      let listOptions = {
        url: this.$api.$board[this.getFunc],
        defaultParams: this.listApiParamSet,
      }
      this.initList('api', listOptions);
      this.page = this.pageClass;
    },

    setData(key, value) {
      this[key] = value;
    },
    settingFilter() {
      this.setFilter('su', this.searchData)
    }


  },
  watch: {
    'boardType': {
      deep: true,
      handler: function () {
        this.$nextTick(() => {
          this.settingFilter()
          this.initConfig()
          this.getList(true)
        })

      }
    },
    'searchData': {
      deep: true,
      handler: function () {
        this.$nextTick(() => {
          this.settingFilter()
          this.initConfig()
          this.getList(true)
        })
      }
    },

  },
}
</script>

<style scoped>

</style>